'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _GraphicViolence = require('./GraphicViolence');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GraphicViolence).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/GraphicViolence/index.js
// module id = 1198
// module chunks = 1